<template>
  <section>
    <div :class="[bindPackageClass, gameName]" :style="pcModuleBackColor">
      <div class="public-package-pad" :style="moduleBackColor">
        <div class="title-container">
          <div class="title" :style="mFontColor" v-html="skuTitleMsg"></div>
          <SkuTipsPopover />
        </div>

        <div class="card-list" v-if="filterSkulList && filterSkulList.length">
          <template v-for="(item, index) in filterSkulList">
            <div
              @click="handleActive(item, index)"
              :class="binCardClass(item)"
              :key="index"
              :style="[
                activeId === item.skuId ? skuActiveBackColor : skuBackColor,
              ]"
            >
              <div class="lt">
                <div class="lt-card">
                  <template v-if="isNewSkuName(item)">
                    <div class="first-subtitle" :style="mFontColor">
                      {{ hackSkuNameObj(item).firstSubtitle }}
                    </div>
                    <div class="second-subtitle" :style="mFontColor">
                      {{ hackSkuNameObj(item).secondSubtitle }}
                    </div>
                    <div class="third-subtitle" :style="mFontColor">
                      {{ hackSkuNameObj(item).thirdSubtitle }}
                    </div>
                  </template>
                  <template v-else>
                    <div class="price" :style="mFontColor">
                      {{ item.skuName.split('+')[0] }}
                    </div>
                    <div
                      class="price bonusPrice"
                      :style="mFontColor"
                      v-if="item.skuName.indexOf('+') !== -1"
                    >
                      +{{ item.skuName.split('+')[1] }}
                    </div>
                  </template>
                </div>
              </div>
              <div class="rt" v-if="getSkuIcon(item)">
                <img
                  class="logo"
                  :src="getSkuIcon(item).background_url"
                  alt="logo"
                  fetchpriority="high"
                />
              </div>
            </div>
          </template>
        </div>

        <template v-if="isRenderStow">
          <div class="put-away-centent">
            <div
              @click="handleOpen"
              :class="['put-away', isOpen ? 'open' : '']"
              :style="mFontColor"
            >
              <span>{{ isOpen ? foldText : unfoldText }}</span>
              <MBIcon
                :color="mFontColor.color"
                :size="iconArrowSize"
                name="icon-black-arrow"
              />
            </div>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>
<script>
  import MBIcon from '@/components/MBIcon'
  import isEmpty from 'lodash/isEmpty'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import SkuTipsPopover from '@/components/SkuTipsPopover'
  import { mapState, mapMutations, mapGetters } from 'vuex'
  import { createdOrderNeedLoginGames } from '@page_detail/config'
  import { storage } from '@/utils/storage'
  import { isJsonString } from '@/utils/tool'
  export default {
    name: 'New-Public-Sku-Template',
    mixins: [styleConfiguration],
    components: {
      MBIcon,
      SkuTipsPopover,
    },
    data() {
      return {
        filterSkulList: [],
        activeId: '',
        limit: 6,
        renderSkuList: [],
        isOpen: false,
        isRecord: false, // 因为重复渲染的问题，只能本地记录状态 不让SKU收起
      }
    },
    computed: {
      ...mapState(['gameName', 'isMobile', 'isDesktop', 'members', 'currency']),
      ...mapState('detail', ['selectServerItem']),
      ...mapGetters([
        'selectedPackageKey',
        'isAllExternalGames',
        'isRuStarMaker',
        'isShiningNikki',
        'isLogin',
        'isVpnGames',
      ]),
      ...mapGetters('detail', ['filterCurrencySkus', 'vpnGamesSortList']),
      skuTitle() {
        return this.$t(`publicDetails.sku_title`)
      },

      iconArrowSize() {
        if (this.isDesktop) return 14
        if (this.isMobile) return 40
        return 40
      },
      foldText() {
        return this.$t(`publicDetails.fold`)
      },

      unfoldText() {
        return this.$t(`publicDetails.unfold`)
      },

      skuTitleMsg() {
        const isHackRes = createdOrderNeedLoginGames.includes(this.gameName)
        if (this.uidModuleType === 6) return `2.&nbsp;${this.skuTitle}`
        if (this.awardType !== 2) return `1.&nbsp;${this.skuTitle}`
        return isHackRes
          ? `1.&nbsp;${this.skuTitle}`
          : `2.&nbsp;${this.skuTitle}`
      },

      renovateList() {
        let _skulist = []
        const t = this.filterCurrencySkus
        if (Array.isArray(t)) {
          return t
        }

        for (let k in t) {
          let res = t[k].map((i) => i)
          _skulist = _skulist.concat(res)
        }
        return _skulist
      },
      // 是否渲染SKU的收起组件
      isRenderStow() {
        if (this.filterSkulList.length === 0) return false
        // warn: VPN的两个游戏 只显示三个、直接隐藏【收起】的动作
        if (this.isVpnGames) return false
        return this.renovateList && this.renovateList.length > this.limit
      },

      cacheSkuId() {
        return storage.get(this.selectedPackageKey) || null
      },

      isExceedLimit() {
        if (this.renovateList && this.renovateList.length) {
          return this.renovateList.length > this.limit
        }
        return false
      },

      bindPackageClass() {
        const defaultClass = ['public-package']
        let device = ''

        if (this.isDesktop) {
          device = `${defaultClass[0]}-desktop`
        }
        if (this.isMobile) {
          device = `${defaultClass[0]}-mobile`
        }

        return defaultClass.concat(device)
      },

      vpnskulist() {
        return {
          vpnGamesSortList: this.vpnGamesSortList,
          selectServerItem: this.selectServerItem,
        }
      },
    },
    watch: {
      renovateList: {
        handler(newVal) {
          if (this.isVpnGames) return
          const skulist = newVal
          if (!(skulist && skulist.length)) {
            this['detail/setCheckSkuItem']({})
          } else {
            this.togglePayList('init')
            this.openBeyondLimit(skulist)
            this.defaultSelected(skulist)
          }
        },
        deep: true,
        immediate: true,
      },
      vpnskulist: {
        handler(newVal) {
          const { vpnGamesSortList = [], selectServerItem = {} } = newVal
          if (isEmpty(selectServerItem)) return
          if (vpnGamesSortList.length === 0) return

          const result = vpnGamesSortList.filter((item) => {
            const matchNames = item.skuName.split('-')
            if (
              matchNames.length === 2 &&
              matchNames[1] === selectServerItem.serverName
            ) {
              return item
            }
            return false
          })

          this.filterSkulList = result
          this.defaultSelected(result)
        },
        deep: true,
      },
    },
    mounted() {},
    methods: {
      ...mapMutations([
        'detail/setIsVpns',
        'detail/setCheckSkuItem',
        'detail/setSkuCloudControl',
        'detail/setChekOuterSkuItem',
      ]),

      binCardClass(item) {
        let cls = ['card']

        if (this.activeId === item.skuId) {
          cls.push('active')
        }
        if (item.soldOut === 1) {
          cls.push('sold-out')
        }
        if (item && item.__hit) {
          cls.push('hit-seckill')
        }
        return cls
      },

      // 是否显示CMS配置的SkuName新样式
      isNewSkuName(item) {
        return 'firstSubtitle' in item && item.firstSubtitle !== ''
      },

      // CMS新增skuName字段（3个）
      // firstSubtitle、secondSubtitle、thirdSubtitle
      hackSkuNameObj(item) {
        return {
          firstSubtitle: item?.firstSubtitle || '',
          secondSubtitle: item?.secondSubtitle || '',
          thirdSubtitle: item?.thirdSubtitle || '',
        }
      },

      // 选择的SKU大于6 在收起的部分中，默认展开
      openBeyondLimit(_skulist) {
        const sid = this.cacheSkuId
        const cindex = _skulist.findIndex((item) => item.skuId === sid)
        const result = cindex > this.limit - 1
        if (result) {
          this.filterSkulList = this.renovateList
        }
        // 全部渲染、默认展开
        this.isOpen = result
      },

      defaultSelected(skulist) {
        const cSkuid = this.cacheSkuId
        const isContainSku = skulist.find((item) => item.skuId === cSkuid)

        // warn: 默认选中的是未售空的第一个SKU
        // warn: 如果都没有那么直接选择默认第一个保证是有数据渲染的
        const notSoldOutItem =
          skulist.find((item) => item.soldOut == 0) || skulist[0]

        const selectCurrent = this.getSelectCurrent(
          isContainSku,
          notSoldOutItem
        )
        const result = this.hackSelectVpnItem(selectCurrent, skulist)
        this.handleActive(result)
      },

      // 获取默认选择SKU的状态、需要过滤默认选择的时候必须是未售空的状态
      getSelectCurrent(cacheSku, soldOutItem) {
        if (cacheSku) {
          return cacheSku?.soldOut === 1 ? soldOutItem : cacheSku
        }
        return soldOutItem
      },
      //  默认选中当前SKU [VPN 两个CP]
      hackSelectVpnItem(cSkuItem, skulist) {
        if (!this.isVpnGames) return cSkuItem
        const { pid = '' } = this.$route.query
        const pidMaps = {
          monthly: '1',
          quarterly: '3',
          yearly: '12',
        }
        const re = /\d+/g
        const qPid = pidMaps[pid] || null

        let result = cSkuItem
        if (!qPid) return cSkuItem

        result = skulist.find((item) => {
          let skuNameDigit = item.skuName.match(re)
          return skuNameDigit !== null && qPid === skuNameDigit[0]
        })

        return result
      },

      setCacheSkuId(value) {
        storage.set(this.selectedPackageKey, value)
      },

      getSkuIcon({ skuExtraInfo }) {
        if (skuExtraInfo && isJsonString(skuExtraInfo)) {
          return JSON.parse(skuExtraInfo) || {}
        }
        return null
      },

      handleOpen() {
        this.togglePayList('click')
      },

      /**
       * @description:  展开收起
       * @param {Boolean} state
       * @param {String} type 类型、是否是初始渲染、还是点击事件
       * @return {Null}
       */
      togglePayList(type = 'click') {
        // 展示前6条

        const limitList = (this.filterSkulList = this.renovateList.filter(
          (_, index) => index <= this.limit - 1
        ))

        if (type === 'init') {
          const soldOutIndex = this.renovateList.findIndex(
            (item) => item.soldOut == 0
          )
          if (soldOutIndex === -1 || soldOutIndex < this.limit) {
            this.filterSkulList = limitList
            this.isOpen = false
          } else {
            this.filterSkulList = this.renovateList
            this.isOpen = true
          }
        }

        if (type === 'click') {
          if (this.isOpen) {
            this.filterSkulList = limitList
          } else {
            this.filterSkulList = this.renovateList
          }
          this.isOpen = !this.isOpen
        }
      },

      // 选中 || 默认注入 当前的选中态
      handleActive(item) {
        if (item.soldOut === 1) return

        this.setCacheSkuId(item.skuId)
        this.activeId = item.skuId
        this['detail/setCheckSkuItem'](item)
        if (this.isAllExternalGames) {
          const _item = JSON.stringify(item)
          this['detail/setChekOuterSkuItem'](_item)
        }
      },
    },
  }
</script>
<style scoped lang="scss" src="./styles.scss"></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './styles_pc.scss';
  }
  @media (min-width: 768px) and (max-width: 1280px) {
    @import './styles_pc.scss';
  }
  @media (max-width: 900px) {
    @import './900.scss';
  }
</style>
